import { Box, Button, Flex, Input, InputGroup, InputLeftElement, Text } from "@chakra-ui/react";
import React from "react";
import { RiAddFill, RiSearch2Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { openCreateChapterModel } from "../../../modules/admin-modules/models/Actions";
import { brandPalette } from "../../../constants/brandPalette";

const C = {
  primary: brandPalette.primary,
  secondary: brandPalette.accentDark,
  border: brandPalette.stone,
  muted: "rgba(30, 27, 23, 0.6)",
};

const SearchBar = ({
  setAdd,
  setSelectedData,
  searchTerm,
  setSearchTerm,
  pageTitle = "Lessons",
  pageSubtitle = "Course lessons under each course, with visibility and activity toggles.",
  countLabel = "Total lessons:",
  totalCount,
  showAddButton = true,
  addButtonLabel = "Add lesson",
  searchPlaceholder = "Search lessons by name…",
}) => {
  const dispatch = useDispatch();
  const reduxCount = useSelector((state) => state.chapters.count);
  const displayCount = totalCount !== undefined && totalCount !== null ? totalCount : reduxCount ?? 0;

  return (
    <Box px={{ base: 4, md: 8 }} pt={6} pb={0} w="100%">
      <Flex
        align={{ base: "flex-start", md: "flex-end" }}
        justify="space-between"
        gap={6}
        flexDir={{ base: "column", md: "row" }}
        mb={6}
      >
        <Box>
          <Text
            fontSize={{ base: "32px", md: "54px" }}
            fontWeight="800"
            color={C.primary}
            fontFamily="'Amiri', 'Tajawal', sans-serif"
            lineHeight="1"
          >
            {pageTitle}
          </Text>
          <Text mt={3} color={C.muted} fontSize="sm" maxW="lg">
            {pageSubtitle}
          </Text>
          <Text mt={2} fontSize="sm" fontWeight="700" color={C.secondary}>
            {countLabel} {displayCount}
          </Text>
        </Box>

        {showAddButton ? (
          <Flex align="center" gap={3} flexWrap="wrap">
            <Button
              borderRadius="full"
              leftIcon={<RiAddFill />}
              bg={C.primary}
              color={brandPalette.cream}
              px={8}
              py={6}
              fontWeight="800"
              _hover={{ bg: C.secondary }}
              _focus={{ boxShadow: "none" }}
              onClick={() => {
                setSelectedData({});
                setAdd(true);
                dispatch(openCreateChapterModel());
              }}
            >
              {addButtonLabel}
            </Button>
          </Flex>
        ) : null}
      </Flex>

      <Box mb={6} maxW="520px">
        <InputGroup>
          <InputLeftElement pointerEvents="none" h="full">
            <RiSearch2Fill color="rgba(91, 13, 22, 0.5)" fontSize="18px" />
          </InputLeftElement>
          <Input
            placeholder={searchPlaceholder}
            value={searchTerm}
            borderRadius="full"
            border="1px solid"
            borderColor={C.border}
            bg="var(--surface-raised)"
            pl={10}
            _focus={{ borderColor: C.primary, boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.2)" }}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
      </Box>
    </Box>
  );
};

export default SearchBar;
